import type { Frame } from "@/api/spaces";
import { useFramesStore } from "@/stores/frames-store";
import { useWorkspaceConversationOverlay } from "@/stores/workspace-conversation-overlay-store";
import { applyFramePatch } from "@/lib/frame-ingest";
import type { ConversationReadOnlyReason } from "@/lib/conversation-read-only-reason";

let abandonPending: (() => void) | null = null;

/** A superseded visible chat stays readable, but cannot keep claiming to open. */
export function cancelPendingConversationSelection(): void {
  abandonPending?.();
  abandonPending = null;
}

export function trackPendingConversationSelection(frame: Frame): () => void {
  // The pending frame carries the "opening_chat" reason it was built with.
  const opening = frame.metadata?.conversationReadOnlyReason;
  const abandon = () => {
    const reason: ConversationReadOnlyReason = "select_again_to_connect";
    const stored = useFramesStore.getState().framesById[frame.id];
    if (stored && stored.metadata.conversationReadOnlyReason === opening) {
      applyFramePatch(frame.id, {
        metadata: { ...stored.metadata, conversationReadOnlyReason: reason },
      });
    }
    const { overlay, open } = useWorkspaceConversationOverlay.getState();
    if (
      overlay?.frame.id === frame.id &&
      overlay.frame.metadata.conversationReadOnlyReason === opening
    ) {
      open({
        ...overlay,
        frame: {
          ...overlay.frame,
          metadata: {
            ...overlay.frame.metadata,
            conversationReadOnlyReason: reason,
          },
        },
      });
    }
  };
  abandonPending = abandon;
  return () => {
    if (abandonPending === abandon) abandonPending = null;
  };
}
